import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue'; 
import Login from '@/views/auth/Login.vue'; 
import store from '@/store';


import Register from '@/views/auth/register/Register.vue';
import VerifyEmail from '@/views/auth/register/VerifyEmail.vue';
import SetPassword from '@/views/auth/register/SetPassword.vue';
import NextPhase from '@/views/auth/register/NextPhase.vue';  
import ForgotPassword from '@/views/auth/register/ForgotPassword.vue';
import ResetPassword from '@/views/auth/register/ResetPassword.vue';
import EmailCodeConfirm from '@/views/auth/register/EmailCodeConfirm.vue';

import Dashboard from '@/views/dashboard/Dashboard.vue';
import RequestsOverview from '@/views/dashboard/RequestsOverview.vue';
import Connections from '@/views/dashboard/Connections.vue';
import Notifications from '@/views/dashboard/Notifications.vue';
import RequestsDetails from '@/views/dashboard/RequestsDetails.vue';
import Settings from '@/views/dashboard/Settings.vue';

import Impressum from '@/views/Impressum.vue';
import Datenschutz from '@/views/Datenschutz.vue';
  
import Terms from '@/views/Terms.vue';


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {
    path: '/terms',
    name: 'Terms',
    component: Terms
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: Datenschutz
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/verifyEmail',
    name: 'VerifyEmail',
    component: VerifyEmail
  }, 
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  }, 

  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: ResetPassword,
    beforeEnter: (to, from, next) => { 
      if (!to.query.token || !to.query.email) { 
        next({ name: 'Login' }); 
      } else {
        next();  
      }
    }
  },

  {
    path: '/confirmCode',
    name: 'EmailCodeConfirm',
    component: EmailCodeConfirm 
  },
 
  {
    path: '/email-verify',
    name: 'SetPassword',
    component: SetPassword,
    beforeEnter: (to, from, next) => { 
      if (!to.query.id || !to.query.hash || !to.query.signature || !to.query.expires) { 
        next({ name: 'Login' }); 
      } else {
        next();  
      }
    }
  },
  {
    path: '/nextPhase',
    name: 'NextPhase',
    component: NextPhase
  },
  
  {
    path: '/dashboard',
    component: Dashboard,
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: RequestsOverview
      },
      {
        path: 'connections',
        component: Connections
      },
      {
        path: 'notifications',
        component: Notifications
      },
      {
        path: 'notifications/:id?', 
        component: Notifications, 
      },
      {
        path: 'details',
        component: RequestsDetails
      },
      {
        path: 'settings',
        component: Settings
      },
      {
        path: '',
        redirect: '/dashboard/overview', 
      }, 
    ],
  
  },
 
];

const router = createRouter({
  history: createWebHistory(),
  routes, 
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, left: 0 };
  },
});

router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = ['/', '/email', '/login', '/register', '/forgotPassword', '/resetPassword', '/nextPhase', '/email-verify', '/confirmCode', '/verifyEmail', '/impressum', '/datenschutz', '/terms'];
  const authRequired = !publicPages.includes(routeTo.path);

  let loggedUser = localStorage.getItem("user") 
    ? JSON.parse(localStorage.getItem("user")) 
    : store.state.auth.currentUser;
  
  if (authRequired && !loggedUser) {
    return next('/login');
  }
 
  next();  
});
export default router;
